import { KameleoonGoalData } from '@/hooks/kameleoon/kameleoonGoals';
import { useTrackConversion } from '@/hooks/kameleoon/useTrackConversion';

export const useTrackBidPlaced = () => useTrackConversion({ goal: KameleoonGoalData.BidPlaced });
